import styled from 'styled-components';

export const AppWrapper = styled.div`
    color: #fff;

    height: 100dvh;
    width: 100%;

    margin: auto;
    padding-left: 15px;
    padding-right: 15px;

    scroll-behavior: smooth;

    overflow-y: scroll;
    scroll-snap-type: y mandatory;
`;

export const FullHeightSectionWrapper = styled.section`
    position: relative;

    height: 100dvh;
    min-width: auto;
    max-width: 1000px;

    margin: auto;
`;

export const FitContentSectionWrapper = styled.section`
    position: relative;

    height: auto;
    min-width: auto;
    max-width: 1000px;

    margin: auto;

    padding-top: 100px;
`;

export const ScrollSnapAlignWrapper = styled.section`
    scroll-snap-align: start;
`;
